const InputCounter = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.inputCounters = document.getElementsByClassName('js-input-counter');
  };

  const decrementVal = (inputCounterEl) => {
    let inputCounterInputEl = inputCounterEl.querySelector('input[data-bind="counterVal"]');
    let newVal = parseInt(inputCounterInputEl.value) - 1;
    let minVal = inputCounterInputEl.getAttribute('data-min-val');
    if (minVal) {
      if (newVal < minVal) newVal = minVal;
    } else {
      if (newVal < 0) newVal = 0;
    }
    inputCounterInputEl.value = newVal;
    inputCounterInputEl.dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true,
    }));
  };

  const incrementVal = (inputCounterEl) => {
    let inputCounterInputEl = inputCounterEl.querySelector('input[data-bind="counterVal"]');
    let newVal = parseInt(inputCounterInputEl.value) + 1;
    let maxVal = inputCounterInputEl.getAttribute('data-max-val');
    if (maxVal) {
      if (newVal > maxVal) newVal = maxVal;
    }
    inputCounterInputEl.value = newVal;
    inputCounterInputEl.dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true,
    }));
  };

  const init = () => {
    cacheDOM();

    for (let i=0; i < DOM.inputCounters.length; i++) {
      DOM.inputCounters[i].querySelector('[data-bind="incrementVal"]')
        .addEventListener('click', () => {
          incrementVal(DOM.inputCounters[i])
        });

      DOM.inputCounters[i].querySelector('[data-bind="decrementVal"]')
        .addEventListener('click', () => {
          decrementVal(DOM.inputCounters[i]);
        });
    }
  };

  return {
    init,
  };
})();

export default InputCounter;
